import React, { useEffect, useState } from "react";
import { Table } from "react-bootstrap";

import { API_URL } from "../utils/config";
function LeaderboardTable({ endpoint, title }) {
  const [leaderboard, setLeaderboard] = useState([]);
  const [roles, setRoles] = useState([]);
  const [selectedRole, setSelectedRole] = useState("all");
  const companyId = endpoint.split("/").pop();

  useEffect(() => {
    const fetchRoles = async () => {
      try {
        const myHeaders = new Headers();
        myHeaders.append("Authorization", localStorage.getItem("token"));
        const response = await fetch(`${API_URL}/api/roles`, {
          method: "GET",
          headers: myHeaders,
        });
        const data = await response.json();
        setRoles(data.roles);
      } catch (error) {
        console.error("Error fetching roles:", error);
      }
    };

    fetchRoles();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const myHeaders = new Headers();
        myHeaders.append("Authorization", localStorage.getItem("token"));
        const roleQuery = selectedRole !== "all" ? `&role=${selectedRole}` : "";
        const requestOptions = {
          method: "GET",
          headers: myHeaders,
          redirect: "follow",
        };
        const response = await fetch(
          `${API_URL}/api${endpoint}?${roleQuery}`,
          requestOptions
        );
        if (!response.ok) {
          throw new Error("Failed to fetch leaderboard data");
        }
        const data = await response.json();
        console.log(data.leaderboard);
        setLeaderboard(data.leaderboard);
      } catch (error) {
        console.error("Error fetching leaderboard:", error);
      }
    };

    fetchData();
  }, [endpoint, selectedRole]);

  return (
    <div>
      <h4>{title}</h4>
      {companyId && companyId !== "" && companyId !== "null" && (
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginBottom: "10px",
            marginRight: "10px",
          }}
        >
          <select
            className="form-control"
            style={{
              marginLeft: "1000px",
              width: "200px",
              marginBottom: "10px",
            }}
            value={selectedRole}
            onChange={(e) => setSelectedRole(e.target.value)}
          >
            <option value="all">Select a Branch</option>
            {roles.map((role) => (
              <option key={role._id} value={role.name}>
                {role.name}
              </option>
            ))}
          </select>
        </div>
      )}

      <Table striped bordered hover>
        <thead>
          <tr>
            <th>Rank</th>
            <th>Name</th>
            <th>Department</th>
            <th>Score</th>
            <th>Avatar</th>
          </tr>
        </thead>
        <tbody>
          {!companyId || companyId === "" || companyId === "null" ? (
            <tr>
              <td colSpan="5" className="text-center">
                No school selected
              </td>
            </tr>
          ) : leaderboard.length === 0 ? (
            <tr>
              <td colSpan="5" className="text-center">
                No data available
              </td>
            </tr>
          ) : (
            leaderboard.slice(0, 10).map((employee) => (
              <tr key={employee._id}>
                <td>{employee.rank}</td>
                <td>{`${employee.name}`}</td>
                <td>{employee.department}</td>
                <td>{employee.score}</td>
                <td>
                  <img
                    src={
                      employee.avatar.includes("uploads")
                        ? `${API_URL}/${employee.avatar}`
                        : require(`../assets/a${employee.avatar}.png`)
                    }
                    alt="Avatar"
                    style={{
                      width: "50px",
                      height: "50px",
                      borderRadius: "50%",
                    }}
                  />
                </td>
              </tr>
            ))
          )}
        </tbody>
      </Table>
    </div>
  );
}

export default LeaderboardTable;
